// extracted by mini-css-extract-plugin
export default {"container":"MobileNavigation-module__container-r_KZ76","isSearchOpen":"MobileNavigation-module__isSearchOpen-PMdny0","showOverlay":"MobileNavigation-module__showOverlay-Ktyjq2"};